import { apiClient, Auth } from '@/shared/api'

import { TRoomSpaceInfo } from '../model/schema'

export type RoomSpaceInfoParams = {
  roomId: number
}

export const getRoomSpaceInfo = async ({ roomId }: RoomSpaceInfoParams) => {
  const { data } = await apiClient.get<TRoomSpaceInfo>({
    endpoint: `/host/rooms/${roomId}/space-info`,
    auth: Auth.REQUIRED,
  })

  return data
}
